/**
 * A named hole. Every route in the plan exists in the router from Phase 3 so
 * that the header's nav, the deep links and the 404 are all real — a nav item
 * that goes nowhere is indistinguishable from a broken one.
 *
 * It says which phase fills it, so a reviewer clicking around knows the
 * difference between "not built yet" and "broken".
 */

import { AppShell, Header } from '@/components/layout'

export function PlaceholderRoute({ title, phase }: { title: string; phase: string }) {
  return (
    <AppShell header={<Header />}>
      <div className="flex flex-1 flex-col items-center justify-center gap-1 bg-bg-surface">
        <span className="text-title text-text-primary">{title}</span>
        <span className="text-body-sm text-text-tertiary">arrives in {phase}</span>
      </div>
    </AppShell>
  )
}
